module.exports = __webpack_public_path__ + "img/leaf2-white.f338826a.svg";